import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import { Route, withRouter } from 'react-router-dom'
import { PrivateRoute, withAuth } from '../../AuthContext'
import { withSearch } from '../../SearchContext'
import TabLink from '../../Utils/TabLink'
import ListRequests from './ListRequests'

const Col12 = styled.div`
  padding: 0px !important;
`

class RequestsTabs extends Component {
  constructor(props) {
    super(props)
  }

  handleRequestsNav = (i) => {
    const links = this.state.requestsLinks.slice()
    for (const j in links) {
      links[j].isActive = i == j
    }
    this.setState({ requestsLinks: links })
  }

  render() {
    let requestsLinks = [
      {
        path: '/dashboard/requests/past',
        text: 'Past requests',
        isActive: false,
      },
      {
        path: '/dashboard/requests/live',
        text: 'Live requests',
        isActive: true,
      },
      {
        path: '/dashboard/requests/pending',
        text: 'Pending requests',
        isActive: false,
      },
    ]

    for (let i = 0; i < requestsLinks.length; i++) {
      requestsLinks[i].isActive =
        requestsLinks[i].path === this.props.location.pathname ? true : false
    }

    return (
      <section className="dashboard__sub-menu">
        <div className="container">
          <div className="row justify-content-center">
            <Col12 className="col-md-12">
              <div className="contact_form">
                <ul className="nav nav-tabs justify-content-center">
                  {requestsLinks.map((link, i) => (
                    <TabLink
                      props={this.props}
                      path={link.path}
                      text={link.text}
                      isActive={link.isActive}
                      key={link.path}
                    />
                  ))}
                  {console.log(this.props)}
                </ul>
                <Route
                  exact
                  path={'/dashboard/requests/past'}
                  render={(props) => <ListRequests type={'past'} {...props} />}
                />
                <Route
                  exact
                  path={'/dashboard/requests/live'}
                  render={(props) => <ListRequests type={'live'} {...props} />}
                />
                <Route
                  exact
                  path={'/dashboard/requests/pending'}
                  render={(props) => (
                    <ListRequests type={'pending'} {...props} />
                  )}
                />
              </div>
            </Col12>
          </div>
        </div>
      </section>
    )
  }
}

export default withRouter(withAuth(withSearch(RequestsTabs)))
